import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import { FC, ReactNode, useCallback, useEffect, useRef, useState } from 'react';
import { BsPeople } from 'react-icons/bs';
import { FiEdit, FiSearch } from 'react-icons/fi';
import { HiPlus } from 'react-icons/hi';
import { MdFolderDelete } from 'react-icons/md';
import { PiCarProfile, PiPaperPlaneTilt, PiShareFat } from 'react-icons/pi';
import { TbTrash } from 'react-icons/tb';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { AdminTitle } from '../../components/AdminTitle';
import { Loading } from '../../components/Loading';
import ReactSelect from '../../components/ReactSelect';
import { StatusModal } from '../../components/StatusModal';
import { StyledButton } from '../../components/StyledButton';
import { StyledInput } from '../../components/StyledInput';
import { StatusModalConfirmClick } from '../../components/StyledModalConfirmClick';
import NewDataTable from '../../components/StyledTableContentRaw';
import { StyledTooltip } from '../../components/StyledTooltip';
import { useUser } from '../../context/UserContext';
import {
  IDriver,
  deleteDriver,
  deleteMultipleDriver,
  linkVehicleDriver,
  sendInviteDriver,
  useDriverInfo,
} from '../../hooks/useDriver';
import { useVehicleInfo } from '../../hooks/useUserVehicles';
import theme from '../../styles/themes/default';
import { CheckBoxInput } from '../UserVehicles/style';
import { CustomModal } from './CustomModal';
import {
  Actions,
  Alert,
  DriversContainer,
  FiltersContainer,
  InputsModalWrapper,
} from './style';

const linkGoogle =
  'https://play.google.com/store/apps/details?id=br.com.zigauto.src&hl=pt_BR&gl=US';
const linkApple =
  'https://apps.apple.com/br/app/zigauto-ipva-multas-boletos/id1644179126';

const Drivers: FC = () => {
  const { user } = useUser();
  console.log(user);

  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);

  const [textToShow, setTextToShow] = useState('');
  const [text, setText] = useState<string | undefined>(undefined);
  const [emailInvite, setEmailInvite] = useState<string>('');

  const [order, setOrder] = useState<'desc' | 'asc'>('asc');
  const [orderBy, setOrderBy] = useState('updated_at');
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [typeConfirmModal, setTypeConfirmModal] = useState<
    'success' | 'error' | 'warning' | 'info' | 'question'
  >('question');
  const [messageConfirmModal, setMessageConfirmModal] = useState<
    string | ReactNode
  >('');
  const [arrayActionsConfirmModal, setArrayActionsConfirmModal] = useState<
    Array<() => void>
  >([]);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [typeStatusModal, setTypeStatusModal] = useState<'success' | 'error'>(
    'success',
  );
  const [messageStatusModal, setMessageStatusModal] = useState<
    string | ReactNode
  >('');
  const [messageTitleStatusModal, setMessageTitleStatusModal] = useState('');

  const [showVehicleModal, setShowVehicleModal] = useState(false);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [showAlertVehicleModal, setShowAlertVehicleModal] = useState(false);

  const [isChecked, setIsChecked] = useState<{ [key: string]: boolean }>({});
  const [isAllChecked, setIsAllChecked] = useState(false);

  const [vehicles, setVehicles] = useState<
    Array<{ id: number; value: string }>
  >([]);
  const [vehicleSelected, setVehicleSelected] = useState<
    | {
        label: string;
        value: number;
      }
    | undefined
  >();
  const vehicleSelectedRef = useRef<
    { label: string; value: number } | undefined
  >(vehicleSelected);
  vehicleSelectedRef.current = vehicleSelected;

  const [showAlertCopy, setShowAlertCopy] = useState(false);

  const { data, isLoading, error, refetch } = useDriverInfo({
    resultsPerPage: itemsPerPage,
    page: page,
    text: text && text?.length > 2 ? text : undefined,
    orderByDirection: order,
    orderBy,
  });

  const { data: dataVehicle } = useVehicleInfo({
    resultsPerPage: 9999999,
    page: 1,
    orderBy: 'vehicle.placa',
    orderByDirection: 'asc',
  });

  const headers = [
    { label: '' },
    { key: 'name', label: 'Nome' },
    { key: 'email', label: 'E-mail' },
    { key: 'telephone', label: 'Telefone' },
    { label: 'Veículo' },
    { label: 'Ações' },
  ];

  useEffect(() => {
    setPage(1);
  }, [data?.resultsPerPage, data?.total, itemsPerPage]);

  useEffect(() => {
    const refetchNewVehicle = location?.state?.shouldRefetch || false;
    if (refetchNewVehicle) refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.state?.shouldRefetch]);

  const handleFilterPlateOrDriverValue = (event: any) => {
    const upperCaseValue = event.target.value;
    setTextToShow(upperCaseValue);

    upperCaseValue && setText(upperCaseValue.toUpperCase());
  };

  const handleSetPlateOrDriverValue = () => {
    text && setText(text.toUpperCase());
  };

  const handleModalToDeleteVehicle = async (info: any) => {
    setTypeConfirmModal('question');
    setMessageConfirmModal(`Deseja realmente excluir este condutor?`);
    setArrayActionsConfirmModal([() => handleDeleteDriver(info.id)]);
    setShowConfirmModal(true);
  };

  const handleDeleteDriver = async (id: number) => {
    setLoading(true);
    const deleteResult = await deleteDriver(id);
    setLoading(false);
    setShowStatusModal(true);
    setTypeStatusModal(deleteResult.status === 200 ? 'success' : 'error');
    setMessageStatusModal(
      deleteResult.status === 200
        ? 'Registro deletado com sucesso'
        : 'Não foi possível deletar registro: ' + deleteResult.data.message ||
            deleteResult.message,
    );
    await refetch();
  };

  const handleSendInvite = useCallback(async () => {
    try {
      if (user) {
        setLoading(true);

        await sendInviteDriver({
          email: emailInvite,
          sub: user.sub,
        });

        setShowStatusModal(true);
        setShowInviteModal(false);
        setTypeStatusModal('success');
        setMessageTitleStatusModal('Email enviado com sucesso !');
        setMessageStatusModal('Verifique a sua caixa de email');
      }
    } catch (error) {
      setShowStatusModal(true);
      setTypeStatusModal('error');
      setMessageTitleStatusModal('Erro ao enviar o email');
      setMessageStatusModal('Verifique se o email informado está correto');
    } finally {
      setEmailInvite('');
      setLoading(false);
    }
  }, [emailInvite, user?.sub]);

  const handleFormatVehicle = () => {
    const array: any = [];

    dataVehicle?.results.forEach((res) => {
      array.push({ id: res.id, value: res.vehicle.placa });
    });

    setVehicles(array);
  };

  const handleModalLinkUserDriver = (id: number) => {
    setArrayActionsConfirmModal([() => handleLinkVehicle(id)]);
    setShowVehicleModal(true);
  };

  const handleCheckLinkVehicle = (vehicle: any) => {
    if (data?.results.length) {
      if (vehicle) {
        const result = data.results.find(
          (item) => item.userVehicle?.id === vehicle.value,
        );

        if (result) {
          setShowAlertVehicleModal(true);
        }

        setVehicleSelected(vehicle);
      } else {
        setVehicleSelected(undefined);
      }
    }
  };

  const handleLinkVehicle = async (id: number) => {
    if (!vehicleSelectedRef.current) return;

    try {
      if (user) {
        setLoading(true);
        await linkVehicleDriver({
          idDriver: id,
          idUserVehicle: Number(vehicleSelectedRef.current.value),
          sub: user.sub,
        });
        setShowStatusModal(true);
        setTypeStatusModal('success');
        setMessageTitleStatusModal('Condutor vinculado com sucesso !');
        setShowVehicleModal(false);
        setVehicleSelected(undefined);
        await refetch();
      }
    } catch (error) {
      setShowStatusModal(true);
      setTypeStatusModal('error');
      setMessageTitleStatusModal('Erro ao vincular o motorista');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleFormatVehicle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataVehicle]);

  const handleCopy = (value: string) => {
    const inputElement = document.createElement('input');
    inputElement.value = value;
    document.body.appendChild(inputElement);
    inputElement.select();
    document.execCommand('copy');
    document.body.removeChild(inputElement);

    setShowAlertCopy(true);

    setTimeout(() => {
      setShowAlertCopy(false);
    }, 3000);
  };

  const deleteAllDriversSelected = async () => {
    setLoading(true);

    const arrayToDeleteAndSetResult = data?.results?.filter(
      (each) => isChecked[each.email],
    ) as IDriver[];

    const removeIds: number[] = [];

    arrayToDeleteAndSetResult.map((driver) =>
      removeIds.push(driver.id as number),
    );

    try {
      await deleteMultipleDriver({ removeIds });
      setIsAllChecked(false);

      setTypeStatusModal('success');
      setMessageStatusModal('Registros deletados com sucesso');
      setShowStatusModal(true);

      await refetch();
    } catch (error) {
      setTypeStatusModal('error');
      setMessageStatusModal('Erro ao deletar registros');
      setShowStatusModal(true);
    } finally {
      // setIsAllChecked(false);
      setLoading(false);
    }
  };

  const handleSetAllSelected = () => {
    if (!isAllChecked && data?.results && data?.results?.length > 0) {
      const newIsChecked = data.results.reduce(
        (acc, each) => ({ ...acc, [each.email]: true }),
        {},
      );
      setIsChecked(newIsChecked);
      setIsAllChecked(true);
    }
    if (isAllChecked && data?.results && data?.results?.length > 0) {
      const newIsChecked = data.results.reduce(
        (acc, each) => ({ ...acc, [each.email]: false }),
        {},
      );
      setIsChecked(newIsChecked);
      setIsAllChecked(false);
    }
  };

  const handleToDeleteAllSelected = async () => {
    const selectedDrivers = Object.entries(isChecked)
      .filter(([, value]) => value)
      .map(([key]) => key);

    if (selectedDrivers.length === 0) {
      return Swal.fire({
        icon: 'info',
        title: 'Atenção!',
        text: 'Selecione ao menos um condutor para deletar',
        confirmButtonColor: theme.colors.orange.primary,
      });
    }

    setTypeConfirmModal('question');
    setMessageConfirmModal(
      <div>
        <p>Deseja realmente excluir estes condutores?</p>
        <p>Condutores: {selectedDrivers.join(', ')}</p>
      </div>,
    );

    setArrayActionsConfirmModal([() => deleteAllDriversSelected()]);
    setShowConfirmModal(true);
    setIsChecked({});
  };

  useEffect(() => {
    itemsPerPage > 10 && setPage(1);
  }, [itemsPerPage]);

  return (
    <DriversContainer>
      {showConfirmModal && (
        <StatusModalConfirmClick
          type={typeConfirmModal}
          text={messageConfirmModal}
          setModal={setShowConfirmModal}
          callActions={arrayActionsConfirmModal}
          twoButtons={true}
        />
      )}
      {showStatusModal && (
        <StatusModal
          type={typeStatusModal}
          title={messageTitleStatusModal}
          text={messageStatusModal}
          setModal={setShowStatusModal}
        />
      )}
      {showVehicleModal && (
        <CustomModal
          title="Vincular veículo"
          text="Selecione o veículo que deseja vincular a esse condutor."
          buttonText="VINCULAR VEÍCULO"
          setModal={setShowVehicleModal}
          callActions={arrayActionsConfirmModal}
        >
          <ReactSelect
            placeholder="Selecione"
            isLoading={false}
            allOptions={vehicles.map(({ value, id }) => ({
              value: id,
              label: value,
            }))}
            setSelectedOption={handleCheckLinkVehicle}
            value={vehicleSelected}
            name="vehicle-selected"
            isClearable
          />
        </CustomModal>
      )}
      {showInviteModal && (
        <CustomModal
          title="Convidar para o ZigAuto"
          text="Compartilhe o link via email ou clique nos botões abaixo para copiar o link"
          buttonText="Enviar"
          setModal={setShowInviteModal}
          showButton={false}
        >
          <InputsModalWrapper>
            <StyledInput
              placeholder="Digite o e-mail que deseja enviar"
              value={emailInvite}
              onChange={(e) => setEmailInvite(e.target.value)}
              icon={
                <PiPaperPlaneTilt
                  onClick={() => handleSendInvite()}
                  style={{ cursor: 'pointer' }}
                />
              }
            />
            <div className="storeContent">
              <span onClick={() => handleCopy(linkGoogle)}>
                <img
                  alt="Disponível no Google Play"
                  src="https://play.google.com/intl/en_us/badges/static/images/badges/pt-br_badge_web_generic.png"
                  style={{ width: '150px', height: '65px', cursor: 'pointer' }}
                />
              </span>
              <span onClick={() => handleCopy(linkApple)}>
                <img
                  src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/pt-br"
                  alt="Download on the App Store"
                  style={{ width: '150px', height: '83px', cursor: 'pointer' }}
                />
              </span>
            </div>

            <Alert show={showAlertCopy} className="alert">
              Link Copiado com sucesso!
            </Alert>
          </InputsModalWrapper>
        </CustomModal>
      )}
      {showAlertVehicleModal && (
        <CustomModal
          title="Atenção"
          buttonText="Continuar"
          setModal={setShowAlertVehicleModal}
          callActions={arrayActionsConfirmModal}
          denyButon
          showButton
        >
          <p style={{ textAlign: 'center' }}>
            O veículo selecionado já está associado a um condutor. <br /> Deseja
            prosseguir ?
          </p>
        </CustomModal>
      )}
      {loading && <Loading />}
      <AdminTitle
        title="Listagem de Condutores"
        icon={<BsPeople size={24} color="#4D4C4D" />}
      />

      <FiltersContainer>
        <label htmlFor="">
          <StyledInput
            placeholder="Buscar por nome"
            value={textToShow}
            onChange={handleFilterPlateOrDriverValue}
          />
          <span onClick={handleSetPlateOrDriverValue}>
            <FiSearch />
          </span>
        </label>
        <StyledButton
          text="Novo cadastro"
          icon={<HiPlus size={22} />}
          iconPosition="left"
          backgroundColor="#005EAD"
          onClick={() => navigate('create')}
        />
        <StyledButton
          text="Convidar para o ZigAuto"
          icon={<PiShareFat size={24} />}
          onClick={() => setShowInviteModal(true)}
          iconPosition="left"
        />
        <StyledButton
          text="Deletar Selecionados"
          textColor={
            isAllChecked || Object.values(isChecked).some((each) => each)
              ? theme.colors.white
              : theme.colors.gray[600]
          }
          backgroundColor={
            isAllChecked || Object.values(isChecked).some((each) => each)
              ? theme.colors.red.primary
              : theme.colors.red.light
          }
          icon={<MdFolderDelete style={{ fontSize: 24 }} />}
          iconPosition="left"
          onClick={handleToDeleteAllSelected}
        />
      </FiltersContainer>

      <NewDataTable
        title="Listagem de Condutores"
        heads={headers}
        hasPagination
        data={data?.results}
        order={order}
        setOrder={setOrder}
        orderBy={orderBy}
        setOrderBy={setOrderBy}
        page={page}
        setPage={setPage}
        setItemsPerPage={setItemsPerPage}
        nPages={data?.nPages}
        isLoading={isLoading}
        isChecked={isAllChecked}
        setIsChecked={handleSetAllSelected}
        error={error}
        totalItems={10}
        hasCheckbox
        itemsPerPage={itemsPerPage}
      >
        <TableBody>
          {data &&
            data.results?.map((each, i) => (
              <TableRow key={each?.cpf}>
                <td>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      textAlign: 'start',
                      margin: '0 0 0 12px',
                      maxWidth: 'fit-content',
                    }}
                  >
                    <CheckBoxInput
                      type="checkbox"
                      checked={isChecked[each.email]}
                      onChange={() =>
                        setIsChecked((prev) => ({
                          ...prev,
                          [String(each.email)]: !isChecked[each.email],
                        }))
                      }
                    />
                  </div>
                </td>
                <td>{each.name}</td>
                <td>{each.email}</td>
                <td>{each.telephone}</td>
                <td>
                  {vehicles.find((v) => v.id === each.userVehicle?.id)?.value}
                </td>
                <td style={{ textAlign: 'center' }}>
                  <Actions>
                    <StyledTooltip text="Vincular veículo" position="top" arrow>
                      <div>
                        <PiCarProfile
                          size={28}
                          onClick={() =>
                            handleModalLinkUserDriver(Number(each.id))
                          }
                        />
                      </div>
                    </StyledTooltip>
                    <StyledTooltip text="Editar" position="top" arrow>
                      <div>
                        <FiEdit
                          size={22}
                          onClick={() => navigate(`edit/${each.id}`)}
                        />
                      </div>
                    </StyledTooltip>
                    <StyledTooltip text="Deletar" position="top" arrow>
                      <div>
                        <TbTrash
                          size={24}
                          onClick={() => handleModalToDeleteVehicle(each)}
                        />
                      </div>
                    </StyledTooltip>
                    <div></div>
                  </Actions>
                </td>
              </TableRow>
            ))}
        </TableBody>
      </NewDataTable>
    </DriversContainer>
  );
};

export default Drivers;
